/** Site-wide static asset paths (served from /public/uploads/ on production). */
export const SITE_LOGO = "https://inventivepages.com/public/uploads/inventive-ads.png";
export const FOUNDER_FALLBACK_PHOTO = "/public/uploads/hetna-bundela.jpg";
export const FOUNDER_HETNA = "/public/uploads/hetna.png";
export const FOUNDER_ANKIT = "/public/uploads/ankit.png";

/** Resolve asset URL — relative paths use current origin. */
export function assetUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("/")) return path;
  return "/" + path;
}
